import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

export const leaguesMainContent = style({
  display: "grid",
  gap: vars.space.l,
});

export const leagueGridLayout = style({
  display: "grid",
  gridTemplateColumns: "1fr",
  rowGap: vars.space.l,
  "@media": {
    [`screen and (min-width: ${breakpoints[4]})`]: {
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: vars.space.l,
    },
  },
});

export const gridDivider = style({
  gridColumn: "1 / span 2",
  padding: `${vars.space.m} 0`,
});

export const formElementWrapper = style({
  display: "grid",
  gap: vars.space.m,
});

export const formItem = style({
  gridColumn: "span 1",
  gridColumnStart: 1,
});

export const leaguesActionButtons = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
  "@media": {
    [`screen and (min-width: ${breakpoints[2]})`]: {
      flexDirection: "row",
    },
  },
});

/**
 * Controls the flex behavior of action buttons in the layout.
 * On larger screens (>= breakpoints[2]), sets flex: 0 to prevent buttons from growing/shrinking
 * and maintain their natural size based on content.
 */
export const leaguesActionButton = style({
  "@media": {
    [`screen and (min-width: ${breakpoints[2]})`]: {
      flex: 0,
    },
  },
});

export const noteTextStyle = style([
  formItem,
  {
    fontFamily: vars.fonts.bold,
    fontSize: vars.fontSizes.body.m,
    fontWeight: 400,
  },
]);

export const explainSheetStyles = style({
  display: "grid",
  gap: vars.space.m,
  padding: `0 ${vars.space.m} ${vars.space.m}`,
});

// TODO: fix this
export const cupExplainButton = style({
  margin: `${vars.space.l} 0`,
  selectors: {
    "&:hover": {
      textDecoration: "underline",
    },
  },
});

export const cupExplainList = style({
  paddingInlineStart: vars.space.s,
});
